import { createContext, useContext } from "react";

export const UNSUPPORTED_STATUS = {
  supported: false,
  permission: "denied",
  registered: false,
  optedOut: false,
  invite: false,
};

export const PushContext = createContext({
  status: UNSUPPORTED_STATUS,
  busy: false,
  enable: async () => {},
  disable: async () => {},
  dismissInvite: async () => {},
});

export const usePushNotifications = () => useContext(PushContext);
